import { CommonResponse, FgPriceListRequest, FgPriceListRequestDto, FgPriceListResponseModel, ProductAndCategoryReq } from "@gtpl/shared-models/masters";
import { connection } from "..";
import axios from "axios";

export class FgPriceListService {
    activatedeActivate(data: FgPriceListRequest) {
        throw new Error('Method not implemented.');
      }
      URL = connection.DEPLOY_URL + '/fg-pricelist';
    
      async createFgPriceList(req:FgPriceListRequestDto): Promise<FgPriceListResponseModel> {
        return await axios.post(this.URL + '/createFgPriceList', req)
          .then(res => {
            return res.data
          })
      }
      async getAllFgPriceListInfo(): Promise<FgPriceListResponseModel> {
        return await axios.post(this.URL + '/getAllFgPriceListInfo')
          .then(res => {
            return res.data
          })
      }

    async getProductPriceByProductAndCategory(req:ProductAndCategoryReq): Promise<CommonResponse> {
      return await axios.post(this.URL + '/getProductPriceByProductAndCategory',req)
        .then(res => {
          return res.data
        })
    }
}